<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">坐席管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;" @click="$router.go(-1)">坐席列表</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">添加坐席</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="lowerInfoContent">
            <div class="basicinfo ">
                <div class="title">
                    <img src="../../../static/flag.png" alt="">
                    <span>添加坐席</span>
                </div>
                <div class="add-content">
                    <a-form :form="form" :label-col="{ span: 3 }" :wrapper-col="{ span: 12 }">
                        <a-form-item label="坐席类型">
                           <a-radio-group name="radioGroup" :default-value="1" @change="onChangelimit">
                                <a-radio :value="item" :label="item.iskf" v-for="item in rolelist" :key="item.gpid">
                                {{item.title}}
                                </a-radio>
                            </a-radio-group>
                        </a-form-item>

                        <div v-if="ccshow">
                            <a-form-item label="IP/域名">
                                <a-input v-model="ccsipurl"
                                    v-decorator="['ccsipurl',{ rules: [{ required: true, message: '请输入IP/域名' }] },]" placeholder="请输入CCSIPURL"
                                />
                            </a-form-item>
                            <a-form-item label="分机号">
                            <a-input v-model="cc_id"
                                    v-decorator="['cc_id',{ rules: [{ required: true, message: '请输入分机号' }] },]" placeholder="请输入CC坐席工号"
                                />
                            </a-form-item>
                            <a-form-item label="分机密码">
                                <a-input v-model="cc_password"
                                    v-decorator="['cc_password',{ rules: [{ required: true, message: '请输入分机密码' }] },]" placeholder="请确认CC坐席密码"
                                />
                            </a-form-item>
                            <a-divider />
                        </div>
                        


                        <a-form-item label="账号">
                            <a-input v-model="username" auto-complete="off"
                                v-decorator="['username',{ rules: [{ required: true, message: '请输入账号' }] },]" placeholder="请输入账号"
                            />
                        </a-form-item>
                        <a-form-item label="手机">
                           <a-input v-model="telephone"
                                v-decorator="['telephone',{ rules: [{ required: true, message: '请输入手机号' }] },]" placeholder="请输入密码"
                            />
                        </a-form-item>
                        <a-form-item label="密码">
                           <a-input v-model="password" type="password" auto-complete="new-password"
                                v-decorator="['password',{ rules: [{ required: true, message: '请输入密码' }] },]" placeholder="请输入密码"
                            />
                        </a-form-item>

                        <a-form-item label="确认密码">
                            <a-input v-model="password_t" type="password" auto-complete="new-password"
                                v-decorator="['password_t',{ rules: [{ required: true, message: '请确认密码' }] },]" placeholder="请确认密码"
                            />
                        </a-form-item>
                        <a-form-item label="所属项目">
                            <a-select placeholder="请选择所属项目" style="width:240px" @change="xmhandleChange">
                                <a-select-option :value="item.id" v-for="item in projectlist" :key="item.id">
                                    {{item.title}}
                                </a-select-option>
                            </a-select>
                        </a-form-item>

                        <a-form-item label="姓名">
                            <a-input v-model="name"
                                v-decorator="['name',{ rules: [{ required: true, message: '请输入姓名' }] },]" placeholder="请输入姓名"
                            />
                        </a-form-item>
                        <a-form-item label="开始时间">
                           <a-date-picker :locale="locale" @change="onstartChange" />
                        </a-form-item>
                        <a-form-item label="结束时间">
                           <a-date-picker :locale="locale" @change="onendChange" />
                        </a-form-item>
                         <!-- <a-form-item label="是否显示手机">
                           <a-switch checked-children="是" un-checked-children="否" default-checked />
                        </a-form-item> -->
                    </a-form>
                </div>

                <div class="add-button">
                    <a-button icon="close-circle" theme="filled" @click="quitadd">取消</a-button>
                    <a-button icon="check-circle" type="primary" @click="saveuser" theme="filled">保存</a-button>
                    <a-button icon="check-circle" type="primary" @click="saveusernewx" theme="filled">保存并创建下一条</a-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment'
export default {
    data(){
        return{
            form: this.$form.createForm(this, { name: 'coordinated' }),
            locale,
            ccshow:false,

            rolelist:"",
            projectlist:"",
            iskf:"",

            username:"",//用户名
            gpid:"",
            telephone:"",
            password:"",
            password_t:"",
            imid:"", //项目id
            name:"",
            start_time:"",
            end_time:"",
            ccsipurl:"",
            cc_id:"",
            cc_password:""

        }
    },
    mounted(){
        this.getrole()
        this.getproject()
    },
    methods:{
        
        // 角色列表
        getrole(){
            this.$axios.post('/api/system/grouplist',{
                pagesize:100
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.rolelist=res.data.data.data
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
        // 项目列表
        getproject(){
            this.$axios.post('/api/system/itemlist',{

            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.projectlist=res.data.data
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
        // 选择项目
        xmhandleChange(value){
            this.imid=value
        },
        // 开始时间
        onstartChange(date, dateString){
            this.start_time=moment(dateString).unix()
        },
        // 结束时间
        onendChange(date, dateString){
            this.end_time=moment(dateString).unix()
        },

        // 角色选择
        onChangelimit(e){
            console.log(e.target.value.gpid)
            this.iskf=e.target.value.iskf
            this.gpid=e.target.value.gpid
            if(e.target.value.iskf==1){
                this.ccshow=true
            }else{
                this.ccshow=false
            }
        },
        // 取消
        quitadd(){
            this.$router.push({path:'/userlist'});
        },

        // 新增
        saveuser(){
            if(this.telephone==""){
                this.$message.warning("请输入号码！"); 
            }else if(this.username==""){
                this.$message.warning("请输入用户名！"); 
            }else if(this.password!=this.password_t){
                this.$message.warning("确认密码和密码不一致！"); 
            }else if(this.gpid==""){
                this.$message.warning("请选择坐席类型！"); 
            }else{
                if(this.iskf==0){
                    this.$axios.post('/api/system/addadmin',{
                        username:this.username,//用户名
                        gpid:this.gpid,
                        telephone:this.telephone,
                        password:this.password,
                        password_t:this.password_t,
                        imid:this.imid, //项目id
                        name:this.name,
                        start_time:this.start_time,
                        end_time:this.end_time,
                    },{
                        headers: {
                            "token":localStorage.getItem('token'),
                        }
                    }).then((res)=>{
                        if(res.data.code==200){
                            this.$message.success(res.data.msg);
                            this.$router.push({path: '/userlist'});
                        }else{
                            this.$message.error(res.data.msg); 
                        }
                    
                    })
                }else{
                    this.$axios.post('/api/system/addadmin',{
                        username:this.username,//用户名
                        gpid:this.gpid,
                        iskf:this.iskf,
                        telephone:this.telephone,
                        password:this.password,
                        password_t:this.password_t,
                        imid:this.imid, //项目id
                        name:this.name,
                        start_time:this.start_time,
                        end_time:this.end_time,
                        ccsipurl:this.ccsipurl,
                        cc_id:this.cc_id,
                        cc_password:this.cc_password
                    },{
                        headers: {
                            "token":localStorage.getItem('token'),
                        }
                    }).then((res)=>{
                        if(res.data.code==200){
                            this.$message.success(res.data.msg);
                            this.$router.push({path: '/userlist'});
                        }else{
                            this.$message.error(res.data.msg); 
                        }
                    
                    })
                }
               
            }
            

        },

        // 新增并下一条
        saveusernewx(){
            if(this.telephone==""){
                this.$message.warning("请输入号码！"); 
            }else if(this.username==""){
                this.$message.warning("请输入用户名！"); 
            }else if(this.password!=this.password_t){
                this.$message.warning("确认密码和密码不一致！"); 
            }else if(this.gpid==""){
                this.$message.warning("请选择坐席类型！"); 
            }else{
                if(this.iskf==0){
                    this.$axios.post('/api/system/addadmin',{
                        username:this.username,//用户名
                        gpid:this.gpid,
                        telephone:this.telephone,
                        password:this.password,
                        password_t:this.password_t,
                        imid:this.imid, //项目id
                        name:this.name,
                        start_time:this.start_time,
                        end_time:this.end_time,
                    },{
                        headers: {
                            "token":localStorage.getItem('token'),
                        }
                    }).then((res)=>{
                        if(res.data.code==200){
                            
                            this.username="",//用户名
                            this.gpid="",
                            this.telephone="",
                            this.password="",
                            this.password_t="",
                            this.imid="", //项目id
                            this.name="",
                            this.start_time="",
                            this.end_time="",
                            this.ccsipurl="",
                            this.cc_id="",
                            this.cc_password=""
                            this.$message.success(res.data.msg);
                            this.$router.push({path: '/adduser'});
                            
                        }else{
                            this.$message.error(res.data.msg); 
                        }
                    
                    })
                }else{
                    this.$axios.post('/api/system/addadmin',{
                        username:this.username,//用户名
                        gpid:this.gpid,
                        telephone:this.telephone,
                        password:this.password,
                        password_t:this.password_t,
                        imid:this.imid, //项目id
                        name:this.name,
                        start_time:this.start_time,
                        end_time:this.end_time,
                        ccsipurl:this.ccsipurl,
                        cc_id:this.cc_id,
                        cc_password:this.cc_password
                    },{
                        headers: {
                            "token":localStorage.getItem('token'),
                        }
                    }).then((res)=>{
                        if(res.data.code==200){
                            this.username="",//用户名
                            this.gpid="",
                            this.telephone="",
                            this.password="",
                            this.password_t="",
                            this.imid="", //项目id
                            this.name="",
                            this.start_time="",
                            this.end_time="",
                            this.ccsipurl="",
                            this.cc_id="",
                            this.cc_password=""
                            this.$message.success(res.data.msg);
                            this.$router.push({path: '/adduser'});
                            
                        }else{
                            this.$message.error(res.data.msg); 
                        }
                    
                    })
                }
               
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/user/adduser.vue